import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

/**
 * `vocabularyValueLookup` request params
 * (what is used to send to server)
 */
export type VocabularyValueLookupRequestOptions = {
	/** attribute vocabulary id */
	id: number;
	query: string;
};

/**
 * `vocabularyValueLookup` request
 * (what gets sent to the server)
 */
export type VocabularyValueLookupRequest = [
	VocabularyValueLookupRequestOptions['id'],
	VocabularyValueLookupRequestOptions['query'],
];

/**
 * `vocabularyValueLookup` response
 * (what comes back from the server)
 */
export type VocabularyValueLookupResponse =
	SuccessResponse<VocabularyValueLookupResult>;

/**
 * `vocabularyValueLookup` result
 * (what is utilized from the server response)
 */
export type VocabularyValueLookupResult = string[];

export const vocabularyValueLookupEndpoint = 'vocabularyValueLookup';

/**
 * Vocabulary value auto list
 */
export const vocabularyValueLookup = async (
	{id, query}: VocabularyValueLookupRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: VocabularyValueLookupRequest = [id, query];

	return client
		.post<VocabularyValueLookupResponse>(
			vocabularyValueLookupEndpoint,
			requestParams,
			{signal},
		)
		.then((response) => response.data.result);
};

export default vocabularyValueLookup;
